export interface IPolicyholderPaymentNotification {
    id: string;
    policyholderId: string;
    emailAddress: string;
}

export class PolicyholderPaymentNotification implements IPolicyholderPaymentNotification {
    id: string;
    policyholderId: string;
    emailAddress: string;
}